import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { X, ArrowLeft, ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { API } from "@/lib/api";

const DISMISS_KEY = "khuta_bar_dismissed";

const formatDate = (iso, lang) =>
  new Date(`${iso}T12:00:00Z`).toLocaleDateString(lang === "ar" ? "ar-SA-u-ca-gregory-nu-latn" : "en-GB", {
    day: "numeric",
    month: "long",
  });

export const RegistrationAnnouncementBar = () => {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  const [status, setStatus] = useState(null);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(DISMISS_KEY) === "1");

  useEffect(() => {
    if (dismissed) return;
    axios.get(`${API}/khuta-sada/registration-status`).then(({ data }) => setStatus(data)).catch(() => {});
  }, [dismissed]);

  if (dismissed || !status) return null;
  const upcoming = !status.open && status.today < status.opens_at;
  if (!status.open && !upcoming) return null;

  const dismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, "1");
    setDismissed(true);
  };

  const lang = i18n.language;
  const message = status.open
    ? isRTL
      ? `باب التسجيل في برنامج «للخطى صدى» مفتوح حتى ${formatDate(status.closes_at, lang)}`
      : `Registration for "Khuta Sada" is now open until ${formatDate(status.closes_at, lang)}`
    : isRTL
      ? `يُفتح باب التسجيل في برنامج «للخطى صدى» في ${formatDate(status.opens_at, lang)}`
      : `Registration for "Khuta Sada" opens on ${formatDate(status.opens_at, lang)}`;
  const Arrow = isRTL ? ArrowLeft : ArrowRight;

  return (
    <div
      className="relative bg-[#164E63] text-white border-b border-[#D4AF37]/40"
      dir={isRTL ? "rtl" : "ltr"}
      data-testid="registration-announcement-bar"
    >
      <div className="max-w-7xl mx-auto px-10 sm:px-6 py-2.5 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-center">
        <span className="h-1.5 w-1.5 rounded-full bg-[#D4AF37] hidden sm:inline-block" aria-hidden="true" />
        <p className="text-xs sm:text-sm tracking-wide" style={{ fontFamily: isRTL ? "Cairo" : undefined }} data-testid="registration-announcement-text">
          {message}
        </p>
        <Link
          to="/khuta-sada"
          className="group inline-flex items-center gap-1.5 text-xs sm:text-sm font-semibold text-[#D4AF37] hover:text-[#F5D97A] transition-colors duration-200"
          data-testid="registration-announcement-link"
        >
          {status.open ? (isRTL ? "سجّلي الآن" : "Register now") : (isRTL ? "تعرّفي على البرنامج" : "Learn more")}
          <Arrow size={14} className="transition-transform duration-200 group-hover:-translate-x-0.5 rtl:group-hover:translate-x-0.5" />
        </Link>
      </div>
      <button
        type="button"
        onClick={dismiss}
        className={`absolute top-1/2 -translate-y-1/2 ${isRTL ? "left-3" : "right-3"} p-1 rounded-full text-white/70 hover:text-white hover:bg-white/10 transition-colors duration-200`}
        aria-label={isRTL ? "إغلاق الإعلان" : "Close announcement"}
        data-testid="registration-announcement-close"
      >
        <X size={16} />
      </button>
    </div>
  );
};

export default RegistrationAnnouncementBar;
